export default __webpack_public_path__ + "static/media/blue-prince-1.4e58b850.webp";